import { CSSProperties } from 'react';
import FitEconomizePrimary from './FitEconomizePrimary';
import FitEconomizeSecondary from './FitEconomizeSecondary';
export interface FitEconomizeProps {
  text?: string;
  width?: number;
  height?: number;
  matrix?: number[];
  top?: number;
  left?: number;
  right?: number;
  color?: [number, number, number];
  textAlign?: CSSProperties['textAlign'];
  alignItems?: CSSProperties['alignItems'];
  whiteSpace?: CSSProperties['whiteSpace'];
  background?: [number, number, number, number];
  padding?: CSSProperties['padding'];
  rotate?: number;
  fontFamily?: CSSProperties['fontFamily'];
  fontWeight?: CSSProperties['fontWeight'];
  justifyContent?: CSSProperties['justifyContent'];
  backgroundImage?: CSSProperties['backgroundImage'];
  variant?: 'primary' | 'secondary';
  borderRadius?: CSSProperties['borderRadius'];
}

const FitEconomize = (props: FitEconomizeProps) => {
  switch (props.variant ?? 'primary') {
    case 'primary':
      return <FitEconomizePrimary {...props} />;
    case 'secondary':
      return <FitEconomizeSecondary {...props} />;
  }
};

export default FitEconomize;
